import { render, staticRenderFns } from "./GalleryThumbnail.vue?vue&type=template&id=2e9515f8&scoped=true&"
import script from "./GalleryThumbnail.vue?vue&type=script&lang=js&"
export * from "./GalleryThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./GalleryThumbnail.vue?vue&type=style&index=0&id=2e9515f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9515f8",
  null
  
)

export default component.exports